:host {
  display: flex;
  max-width: 100%;
}

.section-detection {
  height: 56px;
  border-top: 1px solid var(--chart-101-pressed-dividers);
  border-bottom: 1px solid var(--chart-101-pressed-dividers);
}

.section-matching,
.section-detection,
.section-info-box {
  padding-left: calc(var(--spacer) * 5.1);
}

gz-single-select[id='detection'],
.inputs-section {
  padding-left: var(--spacer);
}

gz-rule-criteria {
  display: flex;
  margin-bottom: var(--spacer);
}

gz-text[class='label'],
gz-tooltip[class='label'] {
  width: 15%;
}

.add-new-btn {
  margin-left: 15.5%;
}

gz-text {
  display: inline;
}

.content {
  width: 78%;
  display: flex;
  align-items: center;
  padding-left: var(--spacer);
}

.icon {
  font-size: 24px;
  padding-right: var(--spacer);
}

gz-button[id='add-new-button'] {
  width: fit-content;
  .button-text {
    padding-right: var(--spacer);
  }
}

gz-button[id='add-new-button']::part(button) {
  padding: 0 var(--spacer);
}

.delete-rule-btn {
  padding-top: 3px;
}

.alerts-content {
  width: 100%;
}

gz-input[disabled] {
  opacity: 0.6;
}
